"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomHeaders = void 0;
var _contexts = require("../contexts");
const useCustomHeaders = () => {
  const {
    tenant,
    registrationID
  } = (0, _contexts.useConfiguration)();
  const headers = {
    'x-tenant-context': tenant,
    'x-registration-id': registrationID
  };
  return headers;
};
exports.useCustomHeaders = useCustomHeaders;
